import { render } from "./PrincipleScoreBars.vue?vue&type=template&id=72611d4d&scoped=true&ts=true"
import script from "./PrincipleScoreBars.vue?vue&type=script&lang=ts"
export * from "./PrincipleScoreBars.vue?vue&type=script&lang=ts"

import "./PrincipleScoreBars.vue?vue&type=style&index=0&id=72611d4d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72611d4d"]])

export default __exports__